import { OutlinedInput, OutlinedInputProps } from '@aibees/shared/components';
import { useDebounceFn } from '@aibees/shared/hooks';
import type { AdvanceTableFilterParams } from '@aibees/shared/features';
import { classnames } from '@aibees/shared/utils';
import { memo, useState } from 'react';
import { Box } from '@mui/material';

export interface EnrichSearchFilterProps
  extends AdvanceTableFilterParams<{ id: string }> {
  className?: string;
}

export const EnrichSearchFilter = memo(
  ({ className, filters, setFilter }: EnrichSearchFilterProps) => {
    const [inputValue, setInputValue] = useState<string>(filters.id ?? '');

    const handleButtonClick = (value: string) => {
      setFilter('id', value || undefined);
    };

    const handleClickDebounced = useDebounceFn(handleButtonClick, 500);

    const handleKeyDown: OutlinedInputProps['onKeyDown'] = (event) => {
      if (event.key === 'Enter') {
        handleButtonClick(inputValue);
      }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.currentTarget;
      setInputValue(value);
      handleClickDebounced(value);
    };

    return (
      <Box className={classnames('EnrichSearchFilter', className)}>
        <OutlinedInput
          value={inputValue}
          placeholder="Type To Search ..."
          size="small"
          startIcon="search"
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          autoComplete="off"
          fullWidth
          sx={{ flex: 1 }}
        />
      </Box>
    );
  }
);

EnrichSearchFilter.displayName = 'EnrichSearchFilter';
